"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const EventSender_1 = __importDefault(require("./EventSender"));
const MetadataManager_1 = __importDefault(require("./utilities/MetadataManager"));
/**
 * Entrypoint API class for modules.
 */
class ModuleClient {
    /**
     * @param moduleMetadata The module metadata.
     * @param insightsApi The insightsApi instance.
     */
    constructor(moduleMetadata, insightsApi) {
        this.insightsApi = null;
        this.insightsApi = insightsApi;
        this.eventSender = new EventSender_1.default();
        MetadataManager_1.default.registerModule(moduleMetadata);
        this.moduleId = moduleMetadata.moduleId;
        this.eventSender.setTargetModuleId(moduleMetadata.moduleId);
        this.eventSender.sendModuleStartUpEvents();
    }
    /**
     * Send an addToCart event, if application is enabled.
     *
     * @param data The included items in the cart.
     */
    addToCart(data) {
        if (this.insightsApi.isEnabled) {
            this.eventSender.sendAddToCart(data);
        }
    }
    /**
     * Send an addToWishList event, if application is enabled.
     *
     * @param data The included items in the wish list.
     */
    addToWishList(data) {
        if (this.insightsApi.isEnabled) {
            this.eventSender.sendAddToWishList(data);
        }
    }
    /**
     * Send a savePlanner event, if application is enabled.
     *
     * @param designId The design id to save, optional.
     * @param [payload] Optional payload data.
     */
    saveDesign(designId, payload) {
        if (this.insightsApi.isEnabled) {
            this.eventSender.sendSavePlanner(designId, payload);
        }
    }
    /**
     * Send a custom event, if application is enabled.
     *
     * @param data The information about the custom event.
     */
    sendEvent(data) {
        if (this.insightsApi.isEnabled) {
            this.eventSender.sendCustomEvent(data);
        }
    }
    /**
     * Send an initPlanningSession event, if application is enabled.
     *
     * @param designId The design id that started the session.
     * @param source The source of the planning session.
     * @param [payload] Optional payload data.
     * @param [spr] Optional The SPR that was used as base for the planning if any.
     */
    initPlanningSession(designId, source, payload, spr) {
        if (this.insightsApi.isEnabled) {
            this.eventSender.sendInitPlanningSession(designId, source, payload, spr);
        }
    }
    /**
     * Send a design interaction event, if application is enabled.
     *
     * @param designId The design id which was interacted with.
     * @param interaction The interaction source.
     * @param [payload] Optional payload data.
     */
    sendDesignInteractionEvent(designId, interaction, payload) {
        if (this.insightsApi.isEnabled) {
            this.eventSender.sendDesignInteractionEvent(designId, interaction, payload);
        }
    }
    /**
     * Send a article action event, if application is enabled.
     *
     * @param articleId The article id.
     * @param action The action being performed.
     * @param isGlobal Indicate if article id is global or local.
     * @param [payload] Optional payload data.
     */
    articleAction(articleId, action, isGlobal, payload) {
        if (this.insightsApi.isEnabled) {
            this.eventSender.sendArticleAction(articleId, action, isGlobal, payload);
        }
    }
    /**
     * Sets the A/B version for the session to facilitate A/B testing, if application is enabled.
     *
     * @param abVersionName Name of the ab version.
     * @param abVersionVariation Optional ab varation.
     */
    setAbVersion(abVersionName, abVersionVariation) {
        if (this.insightsApi.isEnabled) {
            MetadataManager_1.default.updateModule({
                abVersionName,
                abVersionVariation
            }, this.moduleId);
            this.eventSender.sendSetAbVersion();
        }
    }
    /**
     * Send a flow step event, if the component is enabled.
     *
     * @param flowName Name of the flow.
     * @param stepName Name of the step in the flow.
     * @param stepLevel Level of step in the flow.
     */
    sendUserFlowStep(flowName, stepName, stepLevel, payload) {
        if (this.insightsApi.isEnabled) {
            this.eventSender.sendUserFlowStep(flowName, stepName, stepLevel, payload);
        }
    }
    /**
     * Get user ids.
     *
     * @returns The user ids (sessionId, planningId, longTermId and ipexId).
     */
    getIds() {
        if (this.insightsApi.isEnabled) {
            return this.insightsApi.getIds();
        }
    }
}
exports.default = ModuleClient;
//# sourceMappingURL=ModuleClient.js.map